import { Bank2 } from "react-bootstrap-icons";
import { BankResp } from "../Data/ApiTypes";

export interface PaymentMethodBankProps {
    bankAccount:  BankResp;
    className?:   string;
    activeCount?: number;
}

export function PaymentMethodUsBankAccount( { bankAccount, className = "", activeCount = 0 }: PaymentMethodBankProps ) {
    const isUsed = activeCount > 0;

    return (
        <div
            className={`${className} d-flex flex-column p-3 rounded-3 bg-white w-100`}
            style={{
                minWidth: 170,
                minHeight: 110,
                border: "1px solid #e8e8e8",
                boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
            }}
        >
            {/* Bank icon */}
            <div className="mb-2">
                <Bank2 size={22} className="text-secondary" />
            </div>

            {/* Last 4 */}
            <div className="fw-bold" style={{ fontSize: "0.95rem", letterSpacing: "0.03em" }}>
                •••• {bankAccount.last4Digits}
            </div>

            {/* Bank name + badge row */}
            <div className="d-flex align-items-center justify-content-between mt-auto pt-2">
                <span className="text-secondary text-truncate" style={{ fontSize: "0.78rem", maxWidth: 90 }}>
                    {bankAccount.bank}
                </span>
                {isUsed ? (
                    <span
                        className="px-2 py-1 rounded-pill fw-semibold flex-shrink-0"
                        style={{ fontSize: "0.7rem", background: "#d1fae5", color: "#065f46" }}
                    >
                        {activeCount} active
                    </span>
                ) : (
                    <span
                        className="px-2 py-1 rounded-pill fw-semibold flex-shrink-0"
                        style={{ fontSize: "0.7rem", background: "#f1f1f1", color: "#888" }}
                    >
                        Unused
                    </span>
                )}
            </div>
        </div>
    );
}
